import React, { useEffect, useState } from 'react'
import {
  message,
  Table,
  Space,
  Button,
  Drawer,
  Popconfirm,
  Tooltip,
  Form,
  Input,
  Spin,
  Divider,
  Empty,
  Typography,
} from 'antd'
import {
  EditOutlined,
  DeleteOutlined,
  FullscreenExitOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import { useParams, useHistory, Link } from 'react-router-dom'
import api from '../../services/api'
import { Enviar, Cancelar } from '../../components/Buttons'
import { Container, PageTitle } from '../../components'

const { Column } = Table

function Locais() {
  const { id } = useParams()
  const history = useHistory()
  const [form] = Form.useForm()
  const [clientDataForm, setClientDataForm] = useState([])
  const [locais, setLocais] = useState([])
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [mode, setMode] = useState('insert')
  const [load, setLoad] = useState(false)
  const [local, setLocal] = useState(null)

  useEffect(() => {
    async function loadEquipments() {
      setLoading(true)
      try {
        await api.get(`/local?clientId=${id}`).then(async ({ data }) => {
          setLocais(data)
          setLoading(false)
        })
      } catch (error) {
        setLoading(false)
        setLoad(false)
        message.error('Erro ao carregar os dados, atualize a pagina')
      }
    }
    loadEquipments()
  }, [load])

  useEffect(() => {
    async function loadDataClient() {
      try {
        await api.get(`/client?id=${id}`).then(async ({ data }) => {
          const item = data.filter((itens) => itens.id === +id)
          setClientDataForm(item[0])
          setLoading(false)
        })
      } catch (error) {
        message.error('Erro ao carregar os dados, atualize a pagina')
      }
    }
    loadDataClient()
  }, [load])

  const openDrawer = () => {
    setVisible(true)
  }

  const onClose = () => {
    form.resetFields()
    setMode('insert')
    setVisible(false)
  }

  const routes = [
    {
      path: '',
      breadcrumbName: 'Cadastros',
    },
    {
      path: '/clientes',
      breadcrumbName: 'Clientes',
    },
  ]

  function itemRender(route) {
    return (
      <Link to={{ pathname: route.path }} key={route.breadcrumbName}>
        {route.breadcrumbName}
      </Link>
    )
  }

  return (
    <Container>
      <PageTitle
        title='Locais do Cliente'
        breadcrumb={{ routes, itemRender }}
        breadcrumbRender={(props, breadcrumb) => (
          <div style={{ marginBottom: -4 }}>{breadcrumb}</div>
        )}
        extra={[
          <Button
            size='large'
            type='primary'
            icon={<PlusOutlined />}
            onClick={() => {
              setMode('insert')
              openDrawer()
            }}
            key='1'
          >
            Adicionar Local ao Cliente
          </Button>,
        ]}
      />
      <Table
        dataSource={locais}
        loading={loading}
        rowKey={(record) => record.id}
        size='middle'
        style={{ margin: 20 }}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  <span>Não há registro aqui</span>
                </>
              }
            >
              <Button
                icon={<PlusOutlined />}
                key='insert'
                type='primary'
                size='large'
                onClick={() => {
                  setMode('insert')
                  openDrawer()
                }}
              >
                Adicionar
              </Button>
            </Empty>
          ),
        }}
      >
        <Column title='Local do Cliente' dataIndex='name' key='name' />
        <Column title='Endereço' dataIndex='address' key='address' />
        <Column
          title='Cliente'
          dataIndex='cliente'
          key='cliente'
          render={(_, record) => record.cliente?.razaoSocial}
        />
        <Column
          dataIndex='actions'
          key='actions'
          render={(_, record) => (
            <Space>
              <Tooltip title='Unidades' placement='top'>
                <Button
                  icon={<FullscreenExitOutlined />}
                  onClick={() =>
                    history.push({
                      pathname: `/clientes/${id}/locais/${record.id}/setores`,
                      state: { client: clientDataForm, local: record },
                    })
                  }
                />
              </Tooltip>
              <Tooltip title='Editar' placement='top'>
                <Button
                  icon={<EditOutlined />}
                  onClick={() => {
                    setLocal(record)
                    form.setFieldsValue(record)
                    setMode('update')
                    openDrawer()
                  }}
                />
              </Tooltip>
              <Tooltip title='Excluir local' placement='top'>
                <Popconfirm
                  title='Deseja realmente excluir este item?'
                  okText='Sim'
                  cancelText='Não'
                  onConfirm={async () => {
                    await api
                      .delete(`/local/${record.id}`)
                      .then(() => {
                        message.success('Item excluido com sucesso')
                        setLoad(true)
                      })
                      .catch((e) => {
                        message.error(e.response.data.error)
                      })
                  }}
                >
                  <Button
                    icon={<DeleteOutlined />}
                    style={{ color: '#e80909' }}
                  />
                </Popconfirm>
              </Tooltip>
            </Space>
          )}
        />
      </Table>
      <Drawer
        visible={visible}
        onClose={onClose}
        width={550}
        title='Adicionar Local ao Cliente'
      >
        <Spin spinning={loading}>
          {clientDataForm?.nomeFantasia ? (
            <Typography.Title level={5}>
              Cliente: {clientDataForm.nomeFantasia}
            </Typography.Title>
          ) : null}
          <Form
            form={form}
            layout='vertical'
            style={{ marginTop: 30 }}
            onFinish={(value) => {
              setLoading(true)
              const data = { ...value, clientId: id }
              if (mode === 'insert') {
                api
                  .post('/local', data)
                  .then(() => {
                    setLoading(false)
                    message.success('Cadastro realizado com sucesso!')
                    onClose()
                    setLoad(!load)
                  })
                  .catch((e) => {
                    setLoading(false)
                    if (e.response.data.errors) {
                      e.response.data.errors.forEach((info) => {
                        message.error(info.message)
                      })
                    } else {
                      message.error(e.response.data.error)
                    }
                  })
              } else {
                api
                  .put(`/local/${local.id}`, data)
                  .then(() => {
                    setLoading(false)
                    message.success('Cadastro realizado com sucesso!')
                    onClose()
                    setLoad(!load)
                  })
                  .catch((e) => {
                    setLoading(false)
                    if (e.response.data.errors) {
                      e.response.data.errors.forEach((info) => {
                        message.error(info.message)
                      })
                    } else {
                      message.error(e.response.data.error)
                    }
                  })
              }
            }}
          >
            <Form.Item
              label='Local'
              name='name'
              rules={[
                {
                  required: true,
                  message: 'Por favor, o local deve ser informado',
                },
              ]}
            >
              <Input size='large' />
            </Form.Item>
            <Form.Item
              label='Endereco'
              name='address'
              rules={[
                {
                  required: true,
                  message: 'Por favor, o endereco deve ser informado',
                },
              ]}
            >
              <Input size='large' />
            </Form.Item>
            <Divider style={{ borderColor: '#aaa' }} />
            <div style={{ display: 'flex' }}>
              <Enviar
                disabled={mode === 'view'}
                type='primary'
                htmlType='submit'
                style={{ flex: 1 }}
                size='large'
              >
                Adicionar
              </Enviar>
              <Cancelar
                danger
                onClick={onClose}
                style={{ flex: 1 }}
                size='large'
              >
                Cancelar
              </Cancelar>
            </div>
          </Form>
        </Spin>
      </Drawer>
    </Container>
  )
}

export default Locais
